
import React  , {useState , createContext , useRef  , useContext , useEffect} from "react";
import RestaurentContext from "./rest_context";
import { calculateOriginalPrice , errorToast } from "../functions/mini_func";

const CartContext = createContext();

export const CartContextProvider  = ({children}) => {

   const [selectedfoodItemList, setSelectedfoodItemList] = useState([]);
   const [cartItems, setCartItems] = useState({});
   const [selectedRest, setSelectedRest] = useState(null);
   const [couponAmount, setCouponAmount] = useState(0);
   const [selectedCoupon, setSelectedCoupon] = useState(null);
   const [showAlert, setShowAlert] = useState(false);
   const [seletedFoodItem, setSeletedFoodItem] = useState(null);
   const [payFromWallet, setPayFromWallet] = useState(false);
   let instructionsRef = useRef(null);
   const {tappedStore, setTappedStore} = useContext(RestaurentContext);



   const newCart =  (foodModel , count) => {

        setCartItems({ [foodModel.dbID] : count  });

        setSelectedRest(tappedStore);
        console.log("<-- tapped store is   --->" , tappedStore , "<---    --->" )
        setSelectedfoodItemList([foodModel]);
        
        localStorage.setItem('cart-items' , JSON.stringify( { [foodModel.dbID] : count  })  );
        localStorage.setItem('cart-list' , JSON.stringify( [ foodModel.toJson() ] )  );
        localStorage.setItem('selected-rest' , JSON.stringify( tappedStore)  );
    }
    
    
    const addCartItem =  ( foodModel ,  count) => {
            if(selectedfoodItemList.length !== 0){
                if(selectedRest.dbID == foodModel.restaurantId ){
                    if(count == 0){
                        const filterList = selectedfoodItemList.filter((item)  => item.dbID != foodModel.dbID  );
                        setSelectedfoodItemList(filterList);
                        const filterMap = { ...cartItems };
                        delete filterMap[foodModel.dbID];
                        setCartItems(filterMap);
                        if(filterList.length == 0 ){
                            setSelectedRest(null);
                            localStorage.removeItem('selected-rest');
                            localStorage.removeItem('cart-items');
                            localStorage.removeItem('cart-list');
                            
                            return ;
                        }  
                        localStorage.setItem('cart-items' , JSON.stringify( filterMap)  );
                        localStorage.setItem('cart-list' , JSON.stringify( filterList.map((item) => item.toJson() )));
                    }else{

                        const filterMap = { ...cartItems };
                        filterMap[foodModel.dbID] = count;
                        setCartItems(filterMap);
                        localStorage.setItem('cart-items' , JSON.stringify( filterMap));    

                        const itemExist = selectedfoodItemList.some((item) => item.dbID == foodModel.dbID  );
                        if(!itemExist){
                            const newItemList = [...selectedfoodItemList , foodModel];
                            setSelectedfoodItemList(newItemList);
                            localStorage.setItem('cart-list' , JSON.stringify( newItemList.map((item) => item.toJson() )));
                        }
                    }

                }else{
                    setShowAlert(true);
                    setSeletedFoodItem(foodModel);

              }
            } else{
                newCart(foodModel, count );
            }
            
        } 

 
   
        // Re-validate the applied coupon whenever the cart changes. The discount
        // is computed once when a coupon is tapped (in CouponItems), so without
        // this the couponAmount goes stale on item edits — letting a user drop
        // below minimumOrderValue while keeping the discount. Here we recompute
        // the capped discount on every cart change and remove the coupon if the
        // order no longer qualifies.
        useEffect(() => {
            if (selectedCoupon == null) return;

            let subTotal = 0;
            Object.entries(cartItems).forEach(([key, value]) => {
                const item = selectedfoodItemList.find((it) => it.dbID == key);
                if (item) {
                    subTotal += calculateOriginalPrice(item.discount, parseFloat(item.price)) * value;
                }
            });

            // Cart emptied (e.g. last item removed) — silently clear the coupon.
            if (subTotal <= 0) {
                setSelectedCoupon(null);
                setCouponAmount(0);
                return;
            }

            // No longer meets the minimum order value — remove and notify.
            if (subTotal < parseFloat(selectedCoupon.minimumOrderValue)) {
                errorToast(
                    "Coupon removed",
                    "Order no longer meets the minimum value of " + selectedCoupon.minimumOrderValue + " for " + selectedCoupon.couponCode
                );
                setSelectedCoupon(null);
                setCouponAmount(0);
                return;
            }

            // Recompute the discount with the maximum cap applied.
            const discAmount = subTotal * (parseFloat(selectedCoupon.discount) / 100);
            const capped = discAmount < parseFloat(selectedCoupon.maximumDiscountValue)
                ? Math.trunc(discAmount)
                : parseFloat(selectedCoupon.maximumDiscountValue);

            setCouponAmount((prev) => (prev !== capped ? capped : prev));
        }, [cartItems, selectedfoodItemList, selectedCoupon]);


        const  resetCart = () => {
            setSelectedfoodItemList([]);
            setCartItems({});
            setSelectedRest(null);
            setCouponAmount(0);
            setShowAlert(false);
            setSeletedFoodItem(null);
            setPayFromWallet(false);

            localStorage.removeItem('cart-items');
            localStorage.removeItem('cart-list');
            localStorage.removeItem('selected-rest');
            localStorage.removeItem("razorOrderId");
        }

        
        const values = {
            selectedfoodItemList, setSelectedfoodItemList ,
            cartItems, setCartItems ,
            selectedRest, setSelectedRest ,
            couponAmount, setCouponAmount,
            showAlert, setShowAlert,
            seletedFoodItem, setSeletedFoodItem,
            addCartItem , 
            payFromWallet, setPayFromWallet,
            newCart,
            resetCart,
            instructionsRef,
            selectedCoupon, setSelectedCoupon
        }
    
        return (
        <CartContext.Provider value={values} >
                {children}
        </CartContext.Provider>
        );

    }

export default CartContext;